import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FAQS = [
  {
    q: "What is the USFans Spreadsheet?",
    a: "It's a resource that organizes product and seller information into an easier format for research, comparison and discovery. Instead of jumping between many pages, you can scan everything in one place.",
  },
  {
    q: "How do I use the USFans Spreadsheet?",
    a: "Use it to browse products by category, compare sellers, check shipping details and keep your research organized before you make a purchase.",
  },
  {
    q: "Is the USFans Spreadsheet free?",
    a: "Spreadsheet resources are generally informational. Always check the main website for the latest details, availability and any associated costs.",
  },
  {
    q: "Is USFans safe to use?",
    a: "Always verify sellers, links and payment details independently. Our safety resources explain the key checks to make before any decision.",
  },
  {
    q: "How much is USFans shipping?",
    a: "Shipping costs and delivery times can vary by location and seller. Review the shipping details for each item and check the main website for current information.",
  },
];

export default function Faq() {
  const { t } = useTranslation();
  const { lang } = useParams();
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            {t("faq.title")}
          </h2>
          <p className="text-foreground-600">{t("faq.subtitle")}</p>
        </div>

        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                    {f.q}
                  </span>
                  <span
                    className={`w-7 h-7 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 shrink-0 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-8 text-center">
          <Link
            to={`/${lang}/faq`}
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 font-semibold hover:bg-background-200 transition whitespace-nowrap"
          >
            View All Questions
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}